import React, {PureComponent} from 'react';
import {Modal} from 'react-responsive-modal';
import {subscribeToDriverReply} from "../functions/api";
import {withTranslation} from "react-i18next";

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

class ReplyModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        subscribeToDriverReply(this.props.eventID, this.props.sessionID, false, (err, data) => {
            if (data && data.cid) {

                this.closeModal();

                let textColor = "#FFFFFF";
                let text = "";

                switch (data.bid) {
                    case 1: {
                        text = "OK";
                        textColor = "#009419";
                        break;
                    }
                    case 2: {
                        text = "NOK";
                        textColor = "#940900";
                        break;
                    }
                    case 3: {
                        text = "PIT";
                        textColor = "#000c94";
                        break;
                    }
                    case 4: {
                        // RESERVED, for now does nothing
                        this.closeModal();
                        break;
                    }
                    default: {
                        this.closeModal();
                        break;
                    }
                }

                this.setState({
                    carID: data.cid,
                    driverID: data.did,
                    textColor: textColor,
                    text: text,
                    liveryID: data.cln,
                    msgTimestamp: data.mti,
                }, () => {
                    this.openModal();
                });
            }
        });
    }

    componentWillUnmount() {
        subscribeToDriverReply(this.props.eventID, this.props.sessionID, true, null);
    }

    /* HANDLERS */
    openModal() {
        if ((this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin))) {
            if (Object.keys(this.props.pendingMsgOrg).length > 0) {
                this.setState({
                    modalOpen: true
                });
            }
        } else {
            this.setState({
                modalOpen: true
            });
        }
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    /* RENDER METHODS */
    render() {
        return (
            <Modal open={this.state.modalOpen}
                   onClose={() => {
                   }}
                   animationDuration={200}
                   center={true}
                   classNames={{modal: "small-modal fadeInLeft"}}
                   showCloseIcon={false}
            >
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <h3 className={"text-center App_black_text"} style={{fontSize: 25}}><b>{this.props.t("replyFromVehicle")} <span style={{color: "#a1000c", fontSize: 27}}>#{this.state.liveryID}</span>:</b></h3>
                    </div>
                    <div className={"col-sm-12 text-center"} style={{paddingLeft: 35, paddingRight: 35}}>
                        <h1 className={"App_title"} style={{color: this.state.textColor, fontSize: 70}}>{this.state.text}</h1>
                    </div>
                    <br/>
                    <br/>
                    <div className={"col-sm-12 text-center"}>
                        <button
                            className={"btn App_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20, marginTop: 20}}
                            onClick={this.closeModal}
                        >{this.props.t("ok")}
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default withTranslation("translations")(ReplyModal);
